// @ts-nocheck
const frenchCultureCode = "fr-CA";

export const userPreferredLanguageCustomPropertyName = "userPreferredLanguage";

// currently not used due to technical limitations
export default function getBrowserPreferredLanguageCode(): string | undefined {
    if (IS_SERVER_SIDE) {
        return undefined;
    }

    const prefersFrench = getBrowserLanguageTags()
        .map(languageTag => languageTag.split("-")[0]?.toLowerCase())
        .some(languageCode => languageCode === "fr");

    return prefersFrench ? frenchCultureCode : undefined;
}

function getBrowserLanguageTags(): readonly string[] {
    if (typeof navigator === "undefined") {
        return [];
    }

    return navigator.languages && navigator.languages.length > 0 ? navigator.languages : [navigator.language];
}
